import { Injectable } from '@angular/core';
import { BasePageMetaResolver, Breadcrumb, BreadcrumbMeta, CategoryPageMetaResolver, CmsService, Page, PageDescriptionResolver, PageHeadingResolver, PageMetaResolver, PageType, ProductSearchPage, ProductSearchService, TranslationService } from '@spartacus/core';
import { combineLatest, Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UigCategoryPageMetaResolver extends CategoryPageMetaResolver {

  constructor(
    protected productSearchService: ProductSearchService,
    protected cmsService: CmsService,
    protected translationService: TranslationService,
    protected basePageMetaResolver: BasePageMetaResolver
  ) {
    super(productSearchService, cmsService, translationService, basePageMetaResolver);
    this.pageType = PageType.CATEGORY_PAGE;
    this.pageTemplate = 'ProductListPageTemplate';
  }

  resolveTitle(): Observable<string> {
    return (<Observable<ProductSearchPage>>this.searchPage$).pipe(
      filter((page: ProductSearchPage) => !!page.pagination),
      switchMap((p: ProductSearchPage) => {
        var entry = this.getEntry(p);
        return this.translation.translate('pageMetaResolver.category.title', {
          count: p.pagination?.totalResults,
          query: entry
            ? entry.facetValueName
            : undefined,
        })
      })
    );
  }

  getEntry(p: ProductSearchPage) : Breadcrumb {
    if(p.breadcrumbs?.length) {
      var entry = this.getEntryByCode(p, "uig_category_level3");
      if(entry) {
        return entry;
      }
      entry = this.getEntryByCode(p, "uig_category_level2");
      if(entry) {
        return entry;
      }
      entry = this.getEntryByCode(p, "uig_category_level1");
      if(entry) {
        return entry;
      }
      entry = this.getEntryByCode(p, "allCategories");
      if(entry) {
        return entry;
      }
    }
    return null;
  }

  getEntryByCode(p: ProductSearchPage, code: string) : Breadcrumb {
    var entries = p.breadcrumbs.filter(b => {
      return b.facetCode === code
    });
    if(entries.length > 0) {
      return entries[0];
    }
    else {
      return null;
    }
  }

}
